export default {"gitHash":"124f6e9a8f50d4731f39ef4588649132df21e508","gitHashShort":"124f6e9","time":1693843739627,"platform":"linux","arch":"x64"};